// extracted by mini-css-extract-plugin
export default {"label_spec":"button_label_spec__exhsC","custom_btn_primary":"button_custom_btn_primary__FAXgd","disabled":"button_disabled__ig8Ba"};